module.exports = __webpack_public_path__ + "static/media/navigation_flow.3eb6c38b.jpg";